import produce from 'immer';
import React, {Component, Fragment} from 'react';
import {PortalWithState} from 'react-portal';
import {Spring} from 'react-spring/renderprops';
import {Button, Header, Icon, Popup, Table, Item} from 'semantic-ui-react';
import toastr from 'toastr';

import searchImage from '../assets/search.svg';
import favoritesService from '../../store/services/favorites';
import FormContainer from '../form-components/FormContainer';
import {SerialNumberDetail} from './SerialNumberDetail';
import {ModalWrapper} from '../modal/ModalWrapper';

class Favorites extends Component {
  state = {
    detail: {},
    pageInfo: {
      data: [],
      pageCount: 0,
      totalCount: 0,
    },
  };

  componentDidMount() {
    this._loadPage();
  }

  _loadPage = async (pageParams = {page: 0, pageSize: 25}) => {
    try {
      this.setState({loading: true});
      const {result} = await favoritesService.fetch(pageParams);
      this.setState({pageInfo: result});
    } catch (error) {
    } finally {
      this.setState({loading: false});
    }
  };

  _unfavorite = async favorite => {
    try {
      await favoritesService.unfavorite(favorite.id);
      this._loadPage();
      toastr.success('Favorite removed.');
    } catch (error) {}
  };

  _mutate = mutationFn => {
    this.setState(produce(mutationFn));
  };

  _showDetail = (openPortal, favorite) => {
    openPortal();
    this._mutate(state => {
      state.detail = favorite;
    });
  };

  _renderDetailModal = ({closePortal}) => (
    <Spring from={{right: '-100%'}} to={{right: '0%'}}>
      {styles => (
        <ModalWrapper style={styles}>
          <SerialNumberDetail
            sysRowId={this.state.detail.sysRowId}
            close={closePortal}
          />
        </ModalWrapper>
      )}
    </Spring>
  );

  _renderRow = (favorite, openPortal) => (
    <Table.Row key={favorite.id}>
      <Table.Cell style={{width: 140}} textAlign="center">
        <Popup
          position="top center"
          trigger={
            <Button
              className="clear"
              icon
              onClick={() => this._showDetail(openPortal, favorite)}
            >
              <Icon name="eye" />
            </Button>
          }
          content="VIEW"
        />
        <Popup
          position="top center"
          trigger={
            <Button
              className="clear"
              icon
              onClick={() => this._unfavorite(favorite)}
            >
              <Icon name="trash" />
            </Button>
          }
          content="REMOVE FROM FAVORITES"
        />
      </Table.Cell>
      <Table.Cell>{favorite.serialNum}</Table.Cell>
    </Table.Row>
  );

  render() {
    const {loading, pageInfo} = this.state;
    return (
      <FormContainer loading={loading}>
        <Header as="h1">Saved Items ({pageInfo.totalCount})</Header>
        {!!pageInfo.data.length && (
          <PortalWithState closeOnEsc>
            {({openPortal, closePortal, portal}) => (
              <Fragment>
                <Table basic="very" unstackable>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell collapsing style={{width: 140}} />
                      <Table.HeaderCell>Serial Number</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>

                  <Table.Body>
                    {pageInfo.data.map(favorite =>
                      this._renderRow(favorite, openPortal)
                    )}
                  </Table.Body>
                </Table>
                {portal(this._renderDetailModal({closePortal}))}
              </Fragment>
            )}
          </PortalWithState>
        )}
        {pageInfo.data.length === 0 && (
          <Item.Group>
            <Item>
              <Item.Image size="mini" src={searchImage} />
              <Item.Content verticalAlign="middle">
                <strong>No favorites.</strong>
                <div>
                  <small>
                    You can favorite serial numbers from search results for
                    quicker access.
                  </small>
                </div>
              </Item.Content>
            </Item>
          </Item.Group>
        )}
      </FormContainer>
    );
  }
}

export default Favorites;
